import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import Header from "../../Header";
import { UserProjectUserNameEmail } from "../../../types/admin";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  IconLookup,
  IconDefinition,
  findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { AdminApi } from "../../../Api/AdminApi";
import SortableHeader from "../../../Components/Table/sortableHeader";
import { useSortableTable } from "../../../hooks/useSortableTable";
import ConfirmationModal from "../../../Components/Utils/ConfirmationModal";
import CreateUserProject from "./CreateUserProject";
import { useAdmin } from "../../../Utils/AdminContext";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);

interface ListOfProjectUsersProps {
    projectId: string;
  }
  
function ListOfProjectUsers({ projectId }: ListOfProjectUsersProps) {
  const { instance, accounts } = useMsal();
  const api = new AdminApi(accounts[0], instance);
  const navigate = useNavigate();

  
    const { isAdmin, setIsAdmin } = useAdmin();
    useEffect(() => {
      if (isAdmin === false) {
        navigate('/'); 
      }
    }, [isAdmin, navigate]);
  const fetchProjectUsers = async () => {
    const userData = await api.getUserProjects(projectId);
    setData(userData);
  };

  const {
    sortedData: userProjects,
    setData,
    sortData,
    getSortIndicator,
  } = useSortableTable<UserProjectUserNameEmail>([], fetchProjectUsers);

  useEffect(() => {
    fetchProjectUsers();
  }, []);

  const handleDeleteUserProject = async (userId: string) => {
    setUserToDelete(userId);
    setIsModalOpen(true);
  };

  // modal 
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState<string | null>(null);
  
  const confirmDelete = async () => {
    if (userToDelete) {
      await api.deleteUserProject(projectId, userToDelete);
      setIsModalOpen(false);
      fetchProjectUsers();
    }
  };

  return (
    <>
      <div className="project-container">
          
      <h2 className="container-title">Users </h2>
          <table className="table mt-5">
            <thead>
              <tr>
                <SortableHeader<UserProjectUserNameEmail>
                  label="Email"
                  sortKey="userEmail"
                  sortData={sortData}
                  getSortIndicator={getSortIndicator}
                />
                <SortableHeader<UserProjectUserNameEmail>
                  label="Name"
                  sortKey="userName"
                  sortData={sortData}
                  getSortIndicator={getSortIndicator}
                />
                <SortableHeader<UserProjectUserNameEmail>
                  label="Role"
                  sortKey="role"
                  sortData={sortData}
                  getSortIndicator={getSortIndicator}
                />
                <SortableHeader<UserProjectUserNameEmail>
                  label="Actions"
                  sortKey="projectId"
                  sortData={sortData}
                  getSortIndicator={getSortIndicator}
                  isAction={true}
                />
              </tr>
            </thead>
            <tbody>
              {userProjects.map((userProject, index) => (
                <tr key={index}>
                  <td>{userProject.userEmail}</td>
                  <td>{userProject.userName}</td>
                  <td>
                    {userProject.role === 1 && "Encoder"}
                    {userProject.role === 2 && "Validator"}
                    {userProject.role === 3 && "Project Verificator"}
                    {userProject.role === 4 && "Project Approver"}</td>
                  <td>
                    {/* <a
                      className="action-button"
                    //   href={`/admin/User/${user.id}`}
                    >
                      <span>Edit user role</span>
                    </a> */}
                    <a
                      className="action-button delete-button"
                      onClick={() => handleDeleteUserProject(userProject.userId)}
                    >
                      <FontAwesomeIcon icon={trashcanDefinition} />
                      <span>Delete user from project</span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
        <ConfirmationModal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          onConfirm={confirmDelete}
          title="Confirm Deletion"
          message="Are you sure you want to remove this user from the project? This action cannot be undone."
          confirmButtonText="Delete"
          cancelButtonText="Cancel"
          requireComment={false}
        />
        </div>
        <CreateUserProject
          projectId={projectId}
          reloadUserProjects={fetchProjectUsers}
          userToExlude={userProjects
            .map(user => user.userEmail)
            .filter((email): email is string => email !== null)}
        />
    </>
  );
}
export default ListOfProjectUsers;